/**
 * The four list pages — Clients, Trials, Payments, Renewals.
 *
 * They differ only by the preset filter their route carries, so one component
 * serves all four rather than four near-identical files.
 */
import { useMemo } from 'react';
import { useApp } from '../store/AppContext.jsx';
import StatCards from '../components/StatCards.jsx';
import FilterCard from '../components/FilterCard.jsx';
import ClientsGrid from '../components/ClientsGrid.jsx';
import ClientGrid from '../components/ClientGrid.jsx';

export default function ClientList({ view }) {
  const { rows, mode, visible, filters, flag, sort, S } = useApp();
  /*
   * Filtered and sorted when something says so, not on every render.
   *
   * `visible` is a useCallback — it memoises the function, not the answer, so
   * a walk and a sort of 1,228 accounts ran again every time anything in the
   * store moved. 50ms, before React had drawn a single row.
   */
  const list = useMemo(() => visible(view), [visible, view, rows, filters, flag, sort, S]);

  const count = `${list.length} of ${rows.length} clients shown`;

  return (
    <>
      {/* The tiles are book-wide totals, not counts of the rows below — the
          line at the top of the table reports that. They are here because they
          are also the fastest way between these four lists: each tile carries a
          preset filter, so Unpaid is one click from Trials. */}
      <StatCards view={view} />
      <FilterCard view={view} />
      {mode === 'grid'
        ? <ClientGrid list={list} count={count} />
        : <ClientsGrid list={list} view={view} />}

    </>
  );
}
